<div class="row" *ngIf="!loading">
  <div class="col-12 col-md-2 mt-4 mb-2">
    @if (isFirstStep && isCustomerService) {
    <div class="pt-1">
      <label for="inputTotalDiscount" class="form-label mb-0" style="width: 90px">{{
        'TOTAL_DISCOUNT_%' | translate
        }}</label>
      <input type="number" class="form-control form-control-sm" style="max-width: 120px" id="inputTotalDiscount"
        [(ngModel)]="totalDiscount" (ngModelChange)="onTotalDiscountChanged()" />
    </div>
    }
    @if (!isCustomerService) {
    <lib-discount-input label="DISCOUNT_CODE" class="d-block" [ngModel]="discountCode ? campaignCode : discountCode"
      (ngModelChange)="discountCode ? campaignCode : (discountCode = $event)"
      (discountDescription)="discountDescription = $event" (discountCode)="setDiscountCode($event)"
      (clearIfIncorrect)="false"></lib-discount-input>
    }
    @if(discountDescription === '') {
    <div class="alert alert-danger discount-description" style="z-index: 1">
      {{ 'INVALID_DISCOUNT_CODE' | translate }}
    </div>
    }
    @if(discountDescription && discountDescription.length > 0) {
    <div class="alert alert-success discount-description" style="z-index: 1">
      {{ discountDescription | translate }}
    </div>
    }
  </div>

  <div *ngIf="hasMultiplePOD && isCustomerService"
    class="col-12 col-md-3 offset-md-4 d-flex flex-column justify-content-end font-weight-bold">
    <p class="mb-0">{{ 'MULTIPLE_POD_CHECKOUT_TEXT_1' | translate }}</p>
    <p class="mb-0">{{ 'MULTIPLE_POD_CHECKOUT_TEXT_2' | translate }}</p>
  </div>

  <div class="col-12 col-md-3 d-flex align-items-end"
    [ngClass]="{'offset-md-7': (!hasMultiplePOD || !isCustomerService)}">
    <div *ngIf="!hidePrices" class="w-100">
      <div class="row pt-1" *ngIf="totalWeightInCart > 0 && isCustomerService">
        <div class="col-7 text-truncate"><span class="font-weight-bold" translate>TOTAL_WEIGHT</span>:</div>
        <div class="col-5 font-weight-bold item-info text-primary text-right">
          <span>{{ totalWeightInCart | number: '1.2-2' }} kg</span>
        </div>
      </div>
      <div class="row pt-1">
        <div class="col-7 text-truncate"><span class="font-weight-bold" translate>ORDER_VALUE</span>:</div>
        <div class="col-5 font-weight-bold item-info text-primary text-right">
          <lib-price [price]="cartTotalValue" [currency]="cartCurrency"></lib-price>
        </div>
      </div>
      @if (!skipAdminCharge && adminCharge > 0 && cartTotalValue < adminChargeMin) { <div class="row pt-1">
        <div class="col-7 text-truncate"><span class="font-weight-bold" translate>ADMIN_CHARGE</span>:</div>
        <div class="col-5 font-weight-bold item-info text-primary text-right">
          <lib-price [price]="adminCharge" [currency]="cartCurrency"></lib-price>
        </div>
    </div>
    }
    @if (displayZeroAdminFee) {
    <div class="row pt-1">
      <div class="col-7 text-truncate"><span class="font-weight-bold" translate>ADMIN_FEE</span>:</div>
      <div class="col-5 font-weight-bold item-info text-primary text-right">
        <lib-price [price]="0" [currency]="cartCurrency"></lib-price>
      </div>
    </div>
    }
    <div class="row pt-1" *ngIf="brokenBoxFee > 0 && !skipBrokenBoxFee">
      <div class="col-7 text-truncate"><span class="font-weight-bold" translate>BROKEN_BOX_FEE</span>:</div>
      <div class="col-5 font-weight-bold item-info text-primary text-right">
        <lib-price [price]="brokenBoxFee" [currency]="cartCurrency"></lib-price>
      </div>
    </div>
    <div class="row pt-1" *ngIf="freightCost > 0 && cartTotalValue < freightCostMin">
      <div class="col-7 text-truncate"><span class="font-weight-bold" translate>FREIGHT</span>:</div>
      <div class="col-5 font-weight-bold item-info text-primary text-right">
        <lib-price [price]="freightCost" [currency]="cartCurrency"></lib-price>
      </div>
    </div>
    <!--<div class="row pt-1 pb-1">
                <div class="col-7 text-truncate">
                    <span class="font-weight-bold" translate>FREIGHT</span>:
                </div>
                <div class="col-5 font-weight-bold item-info text-primary text-right">
                    <lib-price [price]="0" [currency]="cartCurrency"></lib-price>
                </div>
            </div>-->
  </div>
</div>
<div class="col-12 col-md-2"></div>
<div class="col-12">
  <div class="border-bottom"></div>
</div>
</div>
<div class="row" *ngIf="!loading && !hidePrices">
  <div class="col-12 col-md-9"></div>
  <div class="col-12 col-md-3">
    <div class="row pt-2 row-total">
      <div class="col-7 text-truncate"><span class="font-weight-bold" translate>TOTAL</span>:</div>
      <div class="col-5 font-weight-bold item-info text-primary text-right">
        <lib-price [price]="orderTotalValue" [currency]="cartCurrency"></lib-price>
      </div>
    </div>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12" [ngClass]="showSaveQuoteButton ? 'col-md-8' : 'col-md-10'">
    <div *ngIf="!!isCustomerService">
      <h3 style="font-size: 16px;">{{ 'INTERNAL_TEXT' | translate }}</h3>
      <pre style="font-size: inherit;font-weight: bold;font-family: inherit;">{{ customerKusEditText }}</pre>
    </div>
  </div>

  @if (showSaveQuoteButton) {
  <div class="col-12 col-md-2 text-right checkout-col-save-quote">
    <button
      type="button"
      class="btn btn-outline-primary w-100 btn-sm mt-1 checkout-btn-text btn-save-quote"
      (click)="saveQuote()"
      [disabled]="cartTotalItems === 0"
      translate
    >
      SAVE_QUOTE
    </button>
  </div>
  }

  <div class="col-12 col-md-2 text-right" [class.checkout-col-actions]="showSaveQuoteButton">
    @if (!isLastStep) {
    @if (cartTotalValue > minOrderValue || isSales) {
    <button class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn-text" type="button"
      (click)="nextClickedButton()" *ngIf="!isExternalPaymentStep" [disabled]="disableNextButton">
      <span translate>{{ nextBtnText }}</span>
    </button>
    } @else {
    <button type="button" class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn-text" disabled
      translate>
      LOW_VALUE
    </button>
    }
    } @else {
    @if (isCustomerService) {
    <div class="ml-auto text-start" style="max-width: 150px">
      <div class="d-flex align-items-center mb-2">
        <input type="checkbox" id="inlineCheckbox4" class="form-check-input mr-2"
          [(ngModel)]="blockFullAutomationByCSO" />
        <label class="form-check-label" for="inlineCheckbox4">
          {{ 'DISABLE_FULL_AUTOMATION' | translate }}
        </label>
      </div>
    </div>
    }

    @if (showCreateOrder) {
    <div class="col-12 mb-2">
      <button class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn-text" type="button"
        (click)="createOrder()" *ngIf="!isExternalPaymentStep" [disabled]="disableNextButton">
        <span translate>ORDER</span>
      </button>
    </div>
    }
    @if (showApprovalQuote) {
    <div class="col-12 mb-2">
      <button class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn-text" type="button"
        (click)="sendApprovalQuote()" *ngIf="!isExternalPaymentStep" [disabled]="disableNextButton">
        <span translate>OFFER</span>
      </button>
    </div>
    }
    @if (showCreateSampleOrder) {
    <div class="col-12 mb-2">
      <button class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn-text" type="button"
        (click)="createSampleOrder()" *ngIf="!isExternalPaymentStep" [disabled]="disableNextButton">
        <span translate>SAMPLE</span>
      </button>
    </div>
    }
    }

    <!--  Always preselect the Assortment type filter with the values C and S. This is by request from Magnus and Juliette - Adam -->
    @if (isFirstStep) {
      @if (isTemplatePortal) {
        <a class="btn btn-secondary w-100 mt-1 btn-sm border-0 checkout-btn-text" href="#" role="button" translate
          [routerLink]="['/products']" [queryParams]="{ filters: 'ASSORTMENT_TYPE__:__C_____T' }">CONTINUE_SHOPPING</a>
      } @else {
        <a class="btn btn-secondary w-100 mt-1 btn-sm border-0 checkout-btn-text" href="#" role="button" translate
          [routerLink]="['/products']" [queryParams]="{ filters: 'ASSORTMENT_TYPE__:__C_____S' }">CONTINUE_SHOPPING</a>
      }
    } @else {
    <button type="button" class="btn btn-outline-primary btn-sm checkout-btn-previous w-100 mt-1 checkout-btn-text"
      (click)="isFirstStep ? emptyCart() : prevClicked.emit()" translate>
      {{ isFirstStep ? 'EMPTY_CART' : prevBtnText }}
    </button>
    }

    @if (isLastStep) {
    <div class="col-12 mt-2">
      <div class="ml-auto text-start font-weight-bold" style="max-width: 150px">
        <span>{{ 'NO_FREIGHT_NO_VAT' | translate }}</span>
      </div>
    </div>
    }
  </div>
</div>
